import { useEffect } from 'react';
import { CrossIcon, EditIcon, SaveIcon } from '../../../../utils/SVGIcon';
import { CamelCaseToHyphen } from '../../../../utils/TextFormatter';
import cn from '../../../../utils/cn';
import { useBasicSetting } from '../BasicSettingProvider';

export function ActionButton({ type, isEditMode }) {
    const { handleEditClick, handleCancelEditClick, handleSaveClick } = useBasicSetting();
    // --Handle for save click
    if (isEditMode) {
        return (
            <div className="flex items-center justify-end gap-2">
                <button
                    type="button"
                    onClick={() => handleSaveClick(type)}
                    className="bg-primary-100 rounded-full w-8 h-8 p-2 flex items-center justify-center overflow-hidden"
                >
                    <SaveIcon />
                </button>
                <button
                    type="button"
                    onClick={() => handleCancelEditClick()}
                    className="bg-primary-100 text-[#506B76] rounded-full w-8 h-8 p-2 flex items-center justify-center overflow-hidden"
                >
                    <CrossIcon />
                </button>
            </div>
        );
    }

    return (
        <button
            type="button"
            onClick={() => handleEditClick(type)}
            className={cn(
                'bg-primary-100 rounded-full w-8 h-8 p-2 flex items-center justify-center overflow-hidden'
            )}
        >
            <EditIcon className="inline-block" />
        </button>
    );
}

function BasicInfoCard({ formData, title, name, type, icon, customAction }) {
    const { propertyName, handleChange } = useBasicSetting();
    // --Check if the input is in edit mode
    const isEditMode = propertyName?.length && propertyName === CamelCaseToHyphen(name);

    // if isEditMode is true then focus on input
    useEffect(() => {
        if (isEditMode) {
            document.querySelector(`input[name=${name}]`).focus();
        }
    }, [isEditMode, name]);

    return (
        <div
            className={cn(
                'flex justify-between items-center gap-5 w-full py-3 border-b border-primary-100 overflow-hidden box-border'
            )}
        >
            <div className="flex-initial">
                <div className="w-11 h-11 rounded-lg flex items-center justify-center bg-primary-100">
                    {icon}
                </div>
            </div>
            <div className="w-8/12 flex-1">
                <h3 className="text-primary text-base font-normal">{title || '--'}:</h3>
                <input
                    type="text"
                    name={name}
                    value={formData[name]}
                    readOnly={!isEditMode}
                    onChange={handleChange}
                    className={cn(
                        'w-min outline-none text-primary text-base font-medium bg-transparent px-2 rounded-md relative -left-2'
                    )}
                />
            </div>
            {customAction || <ActionButton type={type} isEditMode={isEditMode} />}
        </div>
    );
}

export default BasicInfoCard;
